import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import AdminUsersTable from '../components/AdminUsersTable';

export default function UsersManagementPage() {
  return (
    <DashboardLayout>
      <Box sx={{ width: '100%' }}>
        <Paper
          elevation={0}
          sx={{
            mb: 3, p: { xs: 3, md: 4 }, borderRadius: 3, color: '#fff',
            background: 'linear-gradient(135deg, #1565c0 0%, #1e88e5 55%, #64b5f6 100%)',
            boxShadow: '0 18px 40px rgba(21, 101, 192, 0.18)',
          }}
        >
          <Typography variant="overline" sx={{ opacity: 0.9, letterSpacing: 1.2 }}>Administración</Typography>
          <Typography variant="h3" sx={{ mt: 1, fontSize: { xs: '2rem', md: '2.5rem' }, fontWeight: 700 }}>Gestión de usuarios</Typography>
          <Typography sx={{ mt: 1, maxWidth: 620, opacity: 0.92 }}>
            Da de alta nuevos usuarios, revisa quién tiene acceso al sistema y administra sus permisos.
          </Typography>
        </Paper>

        <Paper elevation={0} sx={{ p: { xs: 3, md: 4 }, borderRadius: 3, border: '1px solid #e3e8ef', boxShadow: '0 12px 28px rgba(15, 23, 42, 0.06)' }}>
          <AdminUsersTable />
        </Paper>
      </Box>
    </DashboardLayout>
  );
}
